import { Images } from '@/ui/assets/images/Images';

export class PRODUCTS_DATA_API {
    constructor(data) {
        this.id = data.id || data._id || data.productId || '';
        this._id = this.id;
        this.name = data.name || 'Sin nombre';
        this.description = data.description || '';
        this.is_active = data.is_active || null;
        this.price = data.price || 0;
        this.image_urls = Array.isArray(data.image_urls) ? data.image_urls : [];
        this.image_url = data.image_url || this.image_urls[0] || 'https://via.placeholder.com/300';
        this.likes_count = Number(data.likes_count) || 0;
        this.rating = data.rating || 0;
        this.category = data.category || data.category || 'all';
        this.comments = Array.isArray(data.comments) ? data.comments : [];
        this.created_at = data.created_at || null;
    }
}

export const PRODUCTS_DATA_LOCAL = [
    {
        _id: "550e8400-e29b-41d4-a716-446655440000",
        name: "Milkshake de Chocolate",
        description: "Cremoso chocolate belga con salsa artesanal y muchasssssssssssssssssssssssssssssssssssssssssssssss cosas mas",
        is_active: false,
        price: 120000,
        image_url: Images.shakeChoco,
        likes_count: 15,
        rating: 4.5,
        category: "cat-frozen-001",
        created_at: {
            "$date": "2026-04-06T00:00:00Z"
        },
        comments: [
            {
                user_id: "user_2a1b3c4d5e",
                user_name: "Juan Pérez",
                comment: "¡Me encantó! La calidad es excelente.",
                avatar_url: "/static/media/addicted-draw-love-svgrepo-com.279518c32b3bfd611ae5.svg",
                stars_given: 5,

                created_at: {
                    $date: "2026-04-06T11:45:00Z"
                }
            },
            {
                user_id: "user_99b2-41d4",
                user_name: "Maria G.",
                comment: "Buen producto, pero tardó un poco en llegar.",
                avatar_url: "/static/media/actor-chaplin-comedy-svgrepo-com.e239598871aa3f3daa8d.svg",
                stars_given: 4,
                created_at: {
                    $date: "2026-04-06T14:20:00Z"
                }
            },
        ],
        images_list: [
            Images.shakeFresa,
            Images.shakeFresa,
            Images.shakeFresa
        ]
    },
    {
        _id: "a33c1290-f91b-47e8-b5da-990033224411",
        name: "Volcán de Dulce de Leche",
        description: "Bizcocho tibio con corazón líquido de dulce de leche, acompañado de helado de vainilla.",
        is_active: true,
        price: 85000,
        image_url: Images.shakeFresa,
        likes_count: 56,
        rating: 4.9,
        category: "cat-desserts-001",
        created_at: {
            "$date": "2026-04-01T00:00:00Z"
        },
        comments: [
            {
                user_id: "user_5z6x7y8w9v",
                user_name: "Lucía Torres",
                comment: "El centro líquido es perfecto. Un postre 10/10.",
                avatar_url: "/static/media/actor-chaplin-comedy-svgrepo-com.e239598871aa3f3daa8d.svg",
                stars_given: 5,
                created_at: {
                    "$date": "2026-04-07T19:00:00Z"
                }
            },
            {
                user_id: "user_k0j1-i2h3",
                user_name: "Andrés B.",
                comment: "Muy rico, pero es bastante dulce, ideal para compartir.",
                avatar_url: "/static/media/addicted-draw-love-svgrepo-com.279518c32b3bfd611ae5.svg",
                stars_given: 4,
                created_at: {
                    "$date": "2026-04-07T20:30:00Z"
                }
            }
        ],
        images_list: [
            Images.shakeFresa,
            Images.shakeFresa,
            Images.shakeFresa
        ]
    }
];